import { ofType } from "redux-observable";
import { catchError, map, switchMap } from "rxjs/operators";
import { PublicBadgeActionsTypes } from "./publicBadgeTypes";
import { getBadgeDataFailed, getBadgeDataSuccess } from "./publicBadgeActions";
import { from, of } from "rxjs";
import dataService from "../../services/dataService";

export const getBadgeDataEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(PublicBadgeActionsTypes.GET_BADGE_DATA),
    switchMap((action: any): any => {
      const bagdeId = action.payload.badgeId;

      return from(dataService.getPublicBadge(bagdeId)).pipe(
        map((response?: any) => {
          return getBadgeDataSuccess(response?.response);
        }),
        catchError((error) => of(getBadgeDataFailed()))
      );
    })
  );
};
